import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ChatbotAnalyticStore } from 'pages/chatbot/pages/chatbotAnalytic/store/chatbotAnalyticStore'

const ChatbotAnalyticContext = createContext<ChatbotAnalyticStore | null>(null)

export const useChatbotAnalyticContext = () => {
  const context = useContext(ChatbotAnalyticContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ChatbotAnalyticProvider')

  return context
}

export const ChatbotAnalyticProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const { agentId } = useParams()
  const store = useMemo(() => {
    if (agentId === null || agentId === undefined) throw new Error('Agent id is not defined')

    return new ChatbotAnalyticStore(+agentId, entities)
  }, [])

  useEffect(() => store.dispose, [])

  return <ChatbotAnalyticContext.Provider value={store}>{children}</ChatbotAnalyticContext.Provider>
}
